import { createFileRoute, notFound } from "@tanstack/react-router";
import membershipStyles from "../styles/use-case-membership.css?url";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { loadMembershipCreator } from "../platform/use-cases";
import { MembershipCreatorPage } from "../platform/use-cases/membership-creator";

/** The Membership creator template's own page (Drate's host only). */
export const Route = createFileRoute("/use-cases/membership-creator")({
  loader: async () => {
    const page = await loadMembershipCreator();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          platformPageHead(platformShellFrom(matches), {
            pathname: "/use-cases/membership-creator",
            title: "Turn your videos, writing and art into a membership | Drate",
            description:
              "Share videos, audio, writing and downloads with your members on your own site. Memberships, a community and your Patreon tiers built in.",
            structuredData: loaderData.structuredData,
          }),
          membershipStyles,
        )
      : {},
  component: () => <MembershipCreatorPage page={Route.useLoaderData()} />,
});
